<template>
  <div id="app">
    <div :class="[isShowBottom?'content_top':'height100']">
      <router-view v-if="isRouterAlive" v-wechat-title="$route.meta.title" :key="$route.path"></router-view>
    </div>
    <Bottom v-if="isShowBottom"></Bottom>
  </div>
</template>

<script>
import Bottom from '@/components/pc/Bottom'
import { mapState } from 'vuex'
// import HelloWorld from './page/HelloWorld.vue'

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  watch: {
    '$route.path': {
      handler: function(){
        // 解决ios手机跳转不刷新问题
        if(this.$route.path=='/h5/login'||this.$route.path=='/pc/login'){
          console.log(this.$route,'ios刷新')
          this.reload()
        }
      },
      // 深度观察监听
      deep: true,
      
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        console.log('路由监听--刷新后')
        location.reload()
        this.isRouterAlive = true
      })
    }
  },
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState({
      isShowBottom: state => state.isShowBottom
    })
  },
  components: {
    Bottom
  },
  beforeCreate () {
  }
}
</script>

<style>
#app {
  height: 100%;
  font-family: PingFang SC;
}
.content_top {
  min-height: 100%;
  padding-bottom: 144px;
}
.height100 {
  height: 100%;
}
</style>
